import React from 'react';
export const OutputContext = React.createContext();
